import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ClientDelegationsPage } from './client-delegations.page';

const routes: Routes = [
  {
    path: '',
    component: ClientDelegationsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientDelegationsPageRoutingModule {}
